import ScrollReveal from "@/components/base/ScrollReveal";

const feelings = [
  {
    icon: "ri-mind-map",
    title: "Anxious or overwhelmed",
    desc: "Racing thoughts, constant worry, a low-level dread you can't shake. Therapy helps you understand the pattern and work through it.",
    iconColor: "#7D54FC",
    iconBg: "rgba(125,84,252,0.1)",
  },
  {
    icon: "ri-emotion-sad-line",
    title: "Flat, disconnected, or low",
    desc: "Going through the motions without feeling present. Therapy helps you reconnect to what actually matters.",
    iconColor: "#3C6FF8",
    iconBg: "rgba(60,111,248,0.1)",
  },
  {
    icon: "ri-user-heart-line",
    title: "Stuck in the same relationship cycles",
    desc: "Arguments that escalate the same way. Distance that keeps growing. It doesn't have to stay that way.",
    iconColor: "#7D54FC",
    iconBg: "rgba(125,84,252,0.1)",
  },
  {
    icon: "ri-scales-3-line",
    title: "Burned out and running on empty",
    desc: "When you've been taking care of everything and everyone except yourself. Therapy helps you slow down and reset.",
    iconColor: "#6B742F",
    iconBg: "rgba(107,116,47,0.1)",
  },
  {
    icon: "ri-route-line",
    title: "At a crossroads",
    desc: "Career changes, life transitions, a sense that something needs to shift but you're not sure where to start.",
    iconColor: "#3C6FF8",
    iconBg: "rgba(60,111,248,0.1)",
  },
  {
    icon: "ri-time-line",
    title: "Like the past is following you",
    desc: "Old wounds that keep showing up in your present life. Understanding where it comes from is usually where real change begins.",
    iconColor: "#B4A6E3",
    iconBg: "rgba(180,166,227,0.15)",
  },
];

export default function YouMightBeFeeling() {
  return (
    <section className="w-full py-14 md:py-20" style={{ background: "linear-gradient(135deg, #F8F5EE 0%, #F3EFE8 40%, #EEE9F2 100%)" }}>
      <div className="w-full px-6 md:px-12 lg:px-20">
        {/* Header */}
        <div className="max-w-xl mb-10 md:mb-12">
          <ScrollReveal variant="fadeIn" delay={0}>
            <span className="font-manrope text-[13px] font-semibold tracking-widest uppercase block mb-4" style={{ color: "#7D54FC" }}>
              Areas of Focus
            </span>
          </ScrollReveal>
          <ScrollReveal variant="fadeUp" delay={80}>
            <h2 className="font-fraunces text-[#2B2B2B] text-4xl md:text-5xl font-light leading-snug">
              We help with what you&apos;re<br />
              <em className="not-italic" style={{ color: "#7D54FC" }}>actually going through</em>
            </h2>
          </ScrollReveal>
        </div>

        {/* Grid - staggered in two rows */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {feelings.map((f, i) => (
            <ScrollReveal key={f.title} variant="fadeUp" delay={i * 80} threshold={0.08}>
              <div className="bg-white/65 border border-white/60 rounded-2xl p-6 md:p-7 hover:bg-white/85 transition-all h-full card-hover">
                <div
                  className="w-10 h-10 flex items-center justify-center rounded-xl mb-4"
                  style={{ backgroundColor: f.iconBg }}
                >
                  <i className={`${f.icon} text-xl`} style={{ color: f.iconColor }}></i>
                </div>
                <h4 className="font-fraunces text-[#2B2B2B] text-lg font-medium mb-2">
                  <a id={`feeling-${i}`}>{f.title}</a>
                </h4>
                <p className="font-manrope text-[#2B2B2B]/78 text-[15px] leading-relaxed">
                  {f.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}